// src/config.js
const config = {
    SITE_NAME: 'voxpop',
    // other settings
};

export default config;